import styled from 'styled-components';
import { COLOR } from '@src/styles/color';
import { BREAKPOINTS } from '@src/styles/config';

const calcMaxWidth = (numberOfElements) => {
  const safeCount = Math.max(numberOfElements || 1, 1);
  if (safeCount === 1) return '100%';
  return `calc((318px * ${safeCount}) + (16px * ${safeCount - 1}))`;
};

export const StyledCreditUsageGuide = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  box-sizing: border-box;

  ${({ $hasPadding, $numberOfElements }) =>
    $hasPadding &&
    `
    max-width: ${calcMaxWidth($numberOfElements)};
    margin: 80px auto 0;
  `};

  @media (max-width: ${BREAKPOINTS.LMD}px) {
    ${({ $hasPadding }) =>
      $hasPadding &&
      `
      margin-top: 24px;
    `};
  }

  @media (max-width: 640px) {
    ${({ $hasPadding }) =>
      $hasPadding &&
      `
      max-width: 100%;
      width: 100%;
      padding: 16px;
    `};
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export const StyledTitle = styled.h2`
  margin: 0;
  font-weight: 700;
  font-size: ${({ $isMobile }) => ($isMobile ? '20px' : '32px')};
  line-height: ${({ $isMobile }) => ($isMobile ? '28px' : '40px')};
  letter-spacing: -0.4px;
  color: ${COLOR.label2[100]};
  text-align: center;
`;
